import BaseDynamicComponent from "%/dynamic-component-editor/classes/base-dynamic-component";
import ComponentName from "%/dynamic-component-editor/options/component-name";
import DisplayName from "%/dynamic-component-editor/options/display-name";
import ComponentDescription from "%/dynamic-component-editor/options/component-description";
import RequiredContexts from "%/dynamic-component-editor/options/required-contexts";
import ComponentProvidesContexts from "%/dynamic-component-editor/options/component-provides-contexts";
import OptionVariables from "%/dynamic-component-editor/options/option-variables";

export default class CustomDynamicComponent extends BaseDynamicComponent {
  // ComponentName and DisplayName are both hidden from the inspector
  // panel: InspectorHeaderV2 already shows/edits the name above the panel,
  // and component-name is an internal identifier the user never needs to
  // re-edit after create. Hiding via option instance (not by filtering in
  // the panel) keeps both classes in the getRootOption fallback flow.
  static standardOptionClasses = [
    new ComponentName("", true),
    new DisplayName("", true),
    ComponentDescription,
    RequiredContexts,
    ComponentProvidesContexts,
    OptionVariables,
  ];
}
